import * as React from 'react';
const SvgTemplate = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={240}
    height={240}
    fill="none"
    viewBox="0 0 240 240"
    {...props}
  >
    <path
      fill="#E9F2FF"
      d="M120.43 204.36c46.39 0 84-37.61 84-84s-37.61-84-84-84-84 37.6-84 84 37.61 84 84 84"
    />
    <path
      fill="#8BF"
      fillRule="evenodd"
      d="M22.93 95.75a1.9 1.9 0 1 0 .002-3.798 1.9 1.9 0 0 0-.002 3.798m0 2.61c2.49 0 4.5-2.01 4.5-4.5s-2.01-4.5-4.5-4.5-4.5 2.01-4.5 4.5 2.01 4.5 4.5 4.5"
      clipRule="evenodd"
    />
    <path
      fill="#CDF"
      fillRule="evenodd"
      d="M128.93 40.75a1.9 1.9 0 1 0 .002-3.798 1.9 1.9 0 0 0-.002 3.798m0 2.61c2.49 0 4.5-2.01 4.5-4.5s-2.01-4.5-4.5-4.5-4.5 2.01-4.5 4.5 2.01 4.5 4.5 4.5"
      clipRule="evenodd"
    />
    <path
      fill="#8BF"
      d="M60.44 26.92c.5-2.09 3.48-2.09 3.98 0l.76 3.17c.18.75.76 1.33 1.51 1.51l3.17.76c2.09.5 2.09 3.48 0 3.98l-3.17.76c-.75.18-1.33.76-1.51 1.51l-.76 3.17c-.5 2.09-3.48 2.09-3.98 0l-.76-3.17c-.18-.75-.76-1.33-1.51-1.51L55 36.34c-2.09-.5-2.09-3.48 0-3.98l3.17-.76c.75-.18 1.33-.76 1.51-1.51z"
    />
    <path
      fill="#CDF"
      d="M215.33 78.01c.53-2.21 3.67-2.21 4.21 0l.71 2.94c.19.79.81 1.41 1.6 1.6l2.93.71c2.21.53 2.21 3.68 0 4.21l-2.93.71c-.79.19-1.41.81-1.6 1.6l-.71 2.94c-.53 2.21-3.67 2.21-4.21 0l-.71-2.94a2.17 2.17 0 0 0-1.6-1.6l-2.93-.71c-2.21-.53-2.21-3.68 0-4.21l2.93-.71a2.17 2.17 0 0 0 1.6-1.6z"
    />
    <path
      fill="#59F"
      d="M79.33 203.01c.53-2.21 3.67-2.21 4.21 0l.71 2.94c.19.79.81 1.41 1.6 1.6l2.93.71c2.21.53 2.21 3.68 0 4.21l-2.93.71c-.79.19-1.41.81-1.6 1.6l-.71 2.94c-.53 2.21-3.67 2.21-4.21 0l-.71-2.94a2.17 2.17 0 0 0-1.6-1.6l-2.93-.71c-2.21-.53-2.21-3.68 0-4.21l2.93-.71a2.17 2.17 0 0 0 1.6-1.6z"
    />
    <path
      fill="#CDF"
      d="M18.49 188.8c-.37-1.47 1-2.78 2.46-2.37l8.04 2.28c1.46.42 1.92 2.25.83 3.3l-6.01 5.78c-1.09 1.05-2.92.53-3.29-.93l-2.03-8.07z"
    />
    <path
      fill="#59F"
      d="M182.03 56H51.54C43.51 56 37 62.51 37 70.54v98.37c0 8.03 6.51 14.54 14.54 14.54h130.49c8.03 0 14.54-6.51 14.54-14.54V70.54c0-8.03-6.51-14.54-14.54-14.54"
    />
    <path
      fill="#16E"
      d="M111.17 68.43H57.23a8.83 8.83 0 0 0-8.83 8.83v47.89a8.83 8.83 0 0 0 8.83 8.83h53.94a8.83 8.83 0 0 0 8.83-8.83V77.26a8.83 8.83 0 0 0-8.83-8.83M84.72 146.23H53.14a4.74 4.74 0 0 0-4.74 4.74v15.14a4.74 4.74 0 0 0 4.74 4.74h31.58a4.74 4.74 0 0 0 4.74-4.74v-15.14a4.74 4.74 0 0 0-4.74-4.74M122.26 146.23h-20.82a4.74 4.74 0 0 0-4.74 4.74v15.14a4.74 4.74 0 0 0 4.74 4.74h20.82a4.74 4.74 0 0 0 4.74-4.74v-15.14a4.74 4.74 0 0 0-4.74-4.74M181.11 71.54h-46.72a.99.99 0 0 0-.99.99v4.24c0 .547.443.99.99.99h46.72a.99.99 0 0 0 .99-.99v-4.24a.99.99 0 0 0-.99-.99M160.39 83.46h-26a.99.99 0 0 0-.99.99v4.24c0 .547.443.99.99.99h26a.99.99 0 0 0 .99-.99v-4.24a.99.99 0 0 0-.99-.99M171.78 95.37h-37.39a.99.99 0 0 0-.99.99v4.24c0 .547.443.99.99.99h37.39a.99.99 0 0 0 .99-.99v-4.24a.99.99 0 0 0-.99-.99"
    />
    <path fill="#CDF" d="M66.86 95a8.1 8.1 0 1 0 0-16.2 8.1 8.1 0 0 0 0 16.2" />
    <mask
      id="a"
      width={72}
      height={66}
      x={48}
      y={68}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="M111.17 68.43H57.23a8.83 8.83 0 0 0-8.83 8.83v47.89a8.83 8.83 0 0 0 8.83 8.83h53.94a8.83 8.83 0 0 0 8.83-8.83V77.26a8.83 8.83 0 0 0-8.83-8.83"
      />
    </mask>
    <g fill="#137" mask="url(#a)">
      <path d="m81.23 100.19-25.07 33.79h54.88l-25.07-33.79a2.95 2.95 0 0 0-4.74 0" />
      <path d="m125.42 79.53-41.97 54.46h83.95z" />
    </g>
    <path
      fill="#16E"
      d="M199.7 127.53h-44.75c-6.241 0-11.3 5.059-11.3 11.3v42.54c0 6.241 5.059 11.3 11.3 11.3h44.75c6.241 0 11.3-5.059 11.3-11.3v-42.54c0-6.241-5.059-11.3-11.3-11.3"
    />
    <path
      fill="#fff"
      d="m189.66 157.58-17.34-10.01c-1.95-1.13-4.39.28-4.39 2.53v19.98c0 2.25 2.43 3.66 4.38 2.54l17.34-9.97c1.95-1.12 1.96-3.94 0-5.07z"
    />
    <path
      fill="#CDF"
      fillRule="evenodd"
      d="M177.43 210.61a1.9 1.9 0 1 0 .002-3.798 1.9 1.9 0 0 0-.002 3.798m0 2.6c2.49 0 4.5-2.01 4.5-4.5s-2.01-4.5-4.5-4.5-4.5 2.01-4.5 4.5 2.01 4.5 4.5 4.5"
      clipRule="evenodd"
    />
    <path
      fill="#59F"
      d="M166.17 28.83c1.37-.24 2.48 1.09 2 2.39l-2.62 7.15c-.48 1.3-2.18 1.6-3.07.54l-4.9-5.84c-.89-1.06-.3-2.69 1.07-2.92l7.51-1.31z"
    />
  </svg>
);
export default SvgTemplate;
